<div class="ui-image-input" [class.ui-image-input-disabled]="disabled">
    @if (label) {
        <label class="ui-field-label">{{ label }}</label>
    }

    <div
        class="ui-image-input-content"
        [class.ui-image-input-dragging]="dragOver"
        (click)="eventChooseFile()"
        (dragover)="eventDragOver($event)"
        (dragleave)="eventDragLeave($event)"
        (drop)="eventDrop($event)"
        role="button"
    >
        @if (hasValue) {
            <img class="ui-image-input-preview" [src]="previewSrc" alt="Preview da imagem">
            <button type="button" class="ui-button ui-image-input-button">
                <span class="ui-button-label">alterar</span>
            </button>
        } @else {
            <div class="ui-image-input-placeholder">
                <i class="ui-icon uii-upload"></i>
                <span>enviar logo</span>
            </div>
        }
    </div>

    <input #fileInput type="file" [accept]="accept" class="ui-image-input-file" (change)="eventFileSelected($event)" [disabled]="disabled">
</div>
